import React from 'react';
import styled from 'styled-components';
import { CloseIcon, FilterIcon, SearchIcon } from '../../../../components/v2/icons';
import { MobXProviderContext, observer } from 'mobx-react';
import { observable } from 'mobx';

export const InputWrapper = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const ButtonWrapper = styled.div<{ bg?: string }>`
    background: ${({ bg }) => bg ? bg : '#F1F4F7'};
    border-radius: 4px;
    width: 40px;
    height: 40px;
    position: relative;
    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const InputComponent = styled.input`
    border: 1px solid #DFDFDF;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    padding-left: 43px;
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
`;
const FilterIconWrapper = styled.div`
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    display: inline-block;
    cursor: pointer;
`;

type InputWithIconProps = {
   
}

export const InputWithIcon: React.FC<InputWithIconProps> = observer(({ }) => {
    const { store } = React.useContext(MobXProviderContext);
    const {updateCustomerSearchInfo} = store;
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
          store.handleSearchCustomer(store.customerSearchInfo);
        }
      }
    return (
        <InputWrapper>
            <SearchIcon />
            <InputComponent
                placeholder='Search...'
                onChange={(e) => {
                updateCustomerSearchInfo({searchInfo: e.target.value});
            }}
                onKeyDown={(e) => {handleKeyDown(e)}}
                value={store.customerSearchInfo.searchInfo}
            />
            {!store.customerSearchInfo.searchInfo ?
                <FilterIconWrapper onClick={() => store.updateCustomerControl({ openFilterModal: true })}>
                    <FilterIcon />
                </FilterIconWrapper>
                : <CloseIcon onClick={() => store.updateCustomerSearchInfo({searchInfo: ''})} />}
        </InputWrapper>
    );
});
